import React, {useState} from "react";
import {
    Box,
    Heading,
    VStack,
    Input,
    Textarea,
    Button
} from "@chakra-ui/react";
import {FormControl, FormLabel} from "@chakra-ui/form-control";
import colors from "../colors";
import {sendMessage} from "../services/mailerService";
import {toaster} from "../components/ui/toaster";

function ContactMe({isDark}) {
    const [formData, setFormData] = useState({name: "", email: "", message: ""});

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData((prev) => ({...prev, [name]: value}));
    };

    async function handleSubmit(e) {
        e.preventDefault();
        try {
            const response = await sendMessage(formData);
            if (response.statusCode === 200) {
                toaster.create({
                    title: "Success",
                    description: "Message sent! Tye will be in touch!",
                    type: "success",
                    duration: 3000,
                    closable: true
                });
                setFormData({name: "", email: "", message: ""});
            } else {
                toaster.create({
                    title: "Error",
                    description: "Your message can not be sent at this time!",
                    type: "error",
                    duration: 3000,
                    closable: true
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    // Theming
    const primaryText = isDark ? colors.brand[50] : colors.gray[700];
    const accentColor = isDark ? colors.teal[500] : colors.brand[500];
    const formBg = isDark ? colors.darkBg : colors.brand[60];
    const borderColor = isDark ? colors.teal[500] : colors.brand[500];

    return (
        <Box py={8} px={{base: 4, md: 8}} mt={4} mb={10} minH="100vh">
            <Heading
                size="xl"
                mb={10}
                textAlign="center"
                color={accentColor}
            >
                Contact Me
            </Heading>

            <Box
                maxW="600px"
                mx="auto"
                p={{base: 4, md: 6}}
                bg={formBg}
                borderRadius="xl"
                border={`1px solid ${borderColor}`}
                boxShadow="md"
            >
                <form onSubmit={handleSubmit}>
                    <VStack spacing={6} align="stretch">
                        <FormControl isRequired>
                            <FormLabel color={primaryText}>Name</FormLabel>
                            <Input
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Your name"
                                borderColor={borderColor}
                                _hover={{borderColor: accentColor, backgroundColor: isDark ? "whiteAlpha.50" : colors.brand[100]}}
                                _focus={{borderColor: accentColor, boxShadow: "outline", backgroundColor: isDark ? "whiteAlpha.50" : colors.brand[100]}}
                                bg={isDark ? colors.darkBg : "whiteAlpha.50"}
                                color={primaryText}
                            />
                        </FormControl>

                        <FormControl isRequired>
                            <FormLabel color={primaryText}>Email</FormLabel>
                            <Input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="you@example.com"
                                borderColor={borderColor}
                                _hover={{borderColor: accentColor, backgroundColor: isDark ? "whiteAlpha.50" : colors.brand[100]}}
                                _focus={{borderColor: accentColor, boxShadow: "outline", backgroundColor: isDark ? "whiteAlpha.50" : colors.brand[100]}}
                                bg={isDark ? colors.darkBg : "whiteAlpha.50"}
                                color={primaryText}
                            />
                        </FormControl>

                        <FormControl isRequired>
                            <FormLabel color={primaryText}>Message</FormLabel>
                            <Textarea
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                placeholder="Type your message here..."
                                rows={6}
                                resize="vertical"
                                borderColor={borderColor}
                                _hover={{borderColor: accentColor, backgroundColor: isDark ? "whiteAlpha.50" : colors.brand[100]}}
                                _focus={{borderColor: accentColor, boxShadow: "outline", backgroundColor: isDark ? "whiteAlpha.50" : colors.brand[100]}}
                                bg={isDark ? colors.darkBg : "whiteAlpha.50"}
                                color={primaryText}
                            />
                        </FormControl>

                        <Button
                            type="submit"
                            alignSelf="center"
                            bg={accentColor}
                            color="white"
                            size="lg"
                            px={8}
                            _hover={{bg: isDark ? colors.teal[400] : "blue.600"}}
                        >
                            Send Message
                        </Button>
                    </VStack>
                </form>
            </Box>
        </Box>
    );
}

export default ContactMe;
